import { AnalyticsScreen } from 'shared/src/context';
import { useGetMarketAnalyticsDefaults } from '../hooks/useLogMarketAnalyticsEvent';

export const MarketAnalyticsProvider = ({
  marketId,
  children,
}: {
  marketId: number;
  children: React.ReactNode;
}) => {
  const getDefaults = useGetMarketAnalyticsDefaults(marketId);

  return (
    <AnalyticsScreen screen="MARKET" getDefaults={getDefaults}>
      {children}
    </AnalyticsScreen>
  );
};
